import { useTranslation } from 'react-i18next'
import { HugeiconsIcon } from '@hugeicons/react'
import { Add01Icon } from '@hugeicons-pro/core-solid-rounded/index'
import { Button } from '@mui/material'
import PropTypes from 'prop-types'

import AppToolbar from './AppToolbar'

const SettingsToolbar = ({ handleCreateOrderClick, isLoading = false }) => {
    const { t } = useTranslation()

    return (
        <AppToolbar>
            <Button
                color="primary"
                data-testid="order-add-new-button"
                disabled={isLoading}
                loading={isLoading}
                loadingPosition="start"
                startIcon={
                    <HugeiconsIcon
                        icon={Add01Icon}
                        size={20}
                    />
                }
                variant="contained"
                onClick={isLoading ? null : handleCreateOrderClick}
            >
                {t(isLoading ? 'Creating order...' : 'Start new order')}
            </Button>
        </AppToolbar>
    )
}

SettingsToolbar.propTypes = {
    handleCreateOrderClick: PropTypes.func,
    isLoading: PropTypes.bool,
}

export default SettingsToolbar
